// src/styles/variables.js
import { css } from 'styled-components';

const variables = css`
  :root {
    /* =========
     * 🎨 Warm peach / navy palette
     * ========= */
    --bg: #fae5df;          /* very light peach */
    --bg-soft: #f5cac2;     /* soft peach */
    --accent: #ed7966;      /* coral/orange accent */

    --dark-navy: #141850;   /* darkest blue */
    --navy: #303179;        /* main blue */
    --light-navy: #f5cac2;  /* used for panels / soft sections */
    --lightest-navy: #fae5df;

    --navy-shadow: rgba(20, 24, 80, 0.25);

    --dark-slate: #2c2444;  /* body text helpers */
    --slate: #3f3563;       /* main body text */
    --light-slate: #7b6fa1;
    --lightest-slate: #141850; /* headings */

    --white: #ffffff;

    /* keep “green” as the main accent because the whole
       codebase uses --green */
    --green: #ed7966;                 /* coral */
    --green-tint: rgba(237, 121, 102, 0.16);

    --pink: #f5cac2;
    --blue: #303179;

    /* the rest of your variables (fonts, sizes, etc.) stay as-is
       ↓↓↓ keep your existing block from here down ↓↓↓ */

    --font-sans: 'Calibre', 'San Francisco', 'SF Pro Text', -apple-system,
      system-ui, sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono',
      monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 60px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s var(--easing);

    --hamburger-width: 30px;

    --ham-before-y: -8px;
    --ham-after-y: 8px;

    --ham-active-before-y: 0;
    --ham-active-after-y: 0;
  }
`;

export default variables;
